<template>
  <div class="w-[134px]">
    <b-form-group
      size="sm"
      class="w-full"
    >
      <b-button
        :id="`periode-${id}`"
        variant="outline-secondary"
        class="w-full p-1 text-left d-flex justify-content-between align-items-center"
        style="height: 37px !important;"
        @click="popoverShow = !popoverShow"
      >
        <span class="text-nowrap truncate text-sm">{{ selectedLabel }}</span>
        <img
          :src="popoverShow ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-up-2.svg' : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-down-1.svg'"
          alt="arrow"
          width="15px"
        >
      </b-button>
      <b-popover
        :id="`periode-${id}-list`"
        :target="`periode-${id}`"
        placement="bottom"
        triggers="manual"
        :show.sync="popoverShow"
      >
        <ul style="margin: -8px -10px -8px -10px;">
          <li
            v-for="(option, idx) in options"
            :key="idx"
          >
            <b-button
              v-if="option.label !== 'Date Picker'"
              class="w-100 text-left"
              variant="light"
              @click="selectOption(option)"
            >
              {{ option.label }}
            </b-button>
            <date-range-picker
              v-else
              ref="picker"
              v-model="dateRange"
              :opens="openDatePicker"
              control-container-class="border-0"
              class="w-100"
              @update="handleDateChange"
            >
              <template v-slot:input="picker">
                <b-button
                  class="w-100 text-left"
                  variant="light"
                >
                  Date Picker
                </b-button>
                <span class="d-none">{{ picker }}</span>
              </template>
            </date-range-picker>
          </li>
        </ul>
      </b-popover>
    </b-form-group>
  </div>
</template>

<script>
import { BPopover } from 'bootstrap-vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

export default {
  name: 'FilterDropdown',
  components: {
    BPopover,
    DateRangePicker,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      default: 'Bulan ini',
    },
    isOpenRight: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      popoverShow: false,
      selectedLabel: this.value,
      dateRange: { startDate: null, endDate: null },
    }
  },
  computed: {
    openDatePicker() {
      return this.isOpenRight ? 'right' : 'left'
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside(event) {
      const mainPopover = document.getElementById(`periode-${this.id}-list`)
      const button = document.getElementById(`periode-${this.id}`)
      const datePickPopover = document.querySelector('.daterangepicker')

      if (
        mainPopover && !mainPopover.contains(event.target)
        && button && !button.contains(event.target)
        && (!datePickPopover || !datePickPopover.contains(event.target))
      ) {
        this.popoverShow = false
      }
    },
    selectOption(option) {
      this.selectedLabel = option.label
      this.popoverShow = false
      this.$emit('change', option.value)
    },
    handleDateChange(value) {
      this.selectedLabel = 'Custom Range'
      this.popoverShow = false
      this.$emit('date-change', {
        startDate: value.startDate,
        endDate: value.endDate,
      })
    },
  },
}
</script>
